import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Loading } from '@salesperformanceint/e4shared';
import { apiGet } from 'services';

export const UserHandle = ({ history, match }) => {
    const user = useSelector(state => state.user.user);

    React.useEffect(() => {
        if (match.params.handle) {
            apiGet(`profile-from-handle/${match.params.handle}`, user.guid, profile => {
                profile && history.push(`/search/${profile.full_Name}`);
            });
        }
    }, [match.params]);

    return <Loading />;
};

export default withRouter(UserHandle);
